export default __webpack_public_path__ + "static/media/calendar-icon.68b09599.svg";